import React, {useEffect} from "react";

import {useModels23Query} from "../query";
import Models23Table from "./index";
import useDataTableSorting from "../../../components/DataTable/useDataTableSorting";
import useDataTablePagination from "../../../components/DataTable/useDataTablePagination";
import useDataTableColoring from "../../../components/DataTable/useDataTableColoring";
import ExportToolbar from "./ExportToolbar";


const initialSorting = [{id: "datetime", desc: true}];


const TableDataLoader = ({filterState, filterProps, map, id__in, dataTableId}) => {
    const sortingState = useDataTableSorting(initialSorting);
    const paginationState = useDataTablePagination({dataTableId});
    const coloringState = useDataTableColoring({dataTableId});

    // Go to first page when the filters change or the sorting changes
    useEffect(() => {
        paginationState.goToFirstPage();
    }, [filterState?.filters, sortingState?.sorting, map.selectedFeatureIds]);

    const station__id__in = [
        ...map.selectedFeatureIds,
        ...(filterState.filterFetchOptions.station__id__in ?? "").split(',')
    ].filter(s => s !== "").join(",")

    const fetchDataOptions = {
        ...paginationState.paginationFetchOptions,
        ...filterState.filterFetchOptions,
        ...sortingState.sortingFetchOptions,
        station__id__in,
        id__in
    }

    const exportFetchDataOptions = {
        ...filterState.filterFetchOptions,
        ...sortingState.sortingFetchOptions,
        station__id__in,
        id__in
    }

    const tableState = {
        ...paginationState,
        ...sortingState,
        ...filterState,
        ...coloringState,
    }

    const dataQuery = useModels23Query(fetchDataOptions);

    return <>
        <Models23Table rows={dataQuery.data?.rows}
                       page_count={dataQuery.data?.page_count}
                       loading={dataQuery.isFetching && dataQuery.isPreviousData}
                       fetchDataOptions={fetchDataOptions}
                       filterProps={filterProps}
                       map={map}
                       dataTableId={dataTableId}
                       {...tableState}/>
        <ExportToolbar models23Filters={exportFetchDataOptions}/>
    </>
}


export default TableDataLoader;